<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';
import Input from 'dashboard/components-next/input/Input.vue';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    default: '',
  },
});

const items = defineModel({
  type: Array,
  required: true,
});

const { t } = useI18n();

const newItem = ref('');

const addItem = () => {
  const value = newItem.value.trim();
  if (!value) return;

  items.value = [...items.value, value];
  newItem.value = '';
};

const removeItem = index => {
  items.value = items.value.filter((_, i) => i !== index);
};
</script>

<template>
  <div class="flex flex-col gap-2">
    <span class="text-sm font-medium text-n-slate-12">{{ props.label }}</span>
    <ul v-if="items.length" class="flex flex-col gap-2 pl-0 mb-0 list-none">
      <li
        v-for="(item, index) in items"
        :key="`${index}-${item}`"
        class="flex items-start justify-between gap-3 px-3 py-2 border rounded-lg border-n-weak bg-n-solid-1"
      >
        <span class="text-sm text-n-slate-12">{{ item }}</span>
        <Button
          ghost
          slate
          xs
          type="button"
          icon="i-lucide-x"
          :aria-label="t('CAPTAIN.ASSISTANTS.CREATE_FLOW.DETAILS.REMOVE')"
          @click="removeItem(index)"
        />
      </li>
    </ul>
    <div class="flex items-center gap-2">
      <Input
        v-model="newItem"
        :placeholder="props.placeholder"
        class="flex-1"
        @enter="addItem"
      />
      <Button
        faded
        slate
        type="button"
        icon="i-lucide-plus"
        :label="t('CAPTAIN.ASSISTANTS.CREATE_FLOW.DETAILS.ADD')"
        @click="addItem"
      />
    </div>
  </div>
</template>
